var $def = require('./$.def');

$def($def.S + $def.F, 'Object', {isObject: require('./$.is-object')});